<template>
    <div class="flex items-center">
        <a 
          @click.stop="params.colDef.CellRendererParams.openSideBar(params.data)"
        >
          {{ params.data.invoice_id }}
        </a>
    </div>
</template>

<script>
export default {
  name: 'InvoiceNumberCell',
  mounted () {
    console.log(this.params)
  }
}
</script>